import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { take } from 'rxjs/operators';
import { ApiError, MessageService } from '../../../../core';
import { FunilVendaSearch, FunilVendaSearchFunilVenda } from '../funil-venda-search';
import { FunilVendaSearchHttpService } from '../services';


@Component({
    selector: 'sgt-funil-venda-select',
    templateUrl: './funil-venda-select.component.html',
    styleUrls: ['./funil-venda-select.component.less']
})
export class FunilVendaSelectComponent implements OnInit {
    search: FunilVendaSearch;

    /** Funil de venda selecionado */
    @Input() funilVenda: FunilVendaSearchFunilVenda;
    /** Funil de venda alterado */
    @Output() funilVendaChange = new EventEmitter<FunilVendaSearchFunilVenda>();
    /** Funil de Vendas */
    @Input() idFunilVenda: number;
    /** Ao alterar o funil de venda */
    @Output() idFunilVendaChange = new EventEmitter<number>();

    /** Tipos das fases para filtrar os funis */
    @Input() tiposFunilVendaFasesFilter: number[] = null
    /** Se deve exibir o title do select */
    @Input() isShowTitle = false;
    /** Se deve exibir a opção de selecionar a opção nula */
    @Input() isShowNull = true;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    /** Flag que determina se possui algum funil de vendas */
    @Output() possuiFunisVendas = new EventEmitter<boolean>();
    /** Após iniciar o select */
    @Output() afterInitialized = new EventEmitter<void>();

    constructor(private messageService: MessageService,
                private funilVendaSearchHttpService: FunilVendaSearchHttpService) { }

    async ngOnInit(): Promise<void> {
        await this.searchFunis();
        setTimeout(() => this.afterInitialized.emit(), 0);
    }

    /** Pesquisa os funis de venda */
    private searchFunis(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.funilVendaSearchHttpService.search(this.tiposFunilVendaFasesFilter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    search => {
                        if (search) {
                            this.search = search;

                            if (this.search.funisVendas?.length > 0) {
                                if (this.idFunilVenda) { // Se for informado um ID de funil de vendas, obtemos e selecionamos ele
                                    const funilVenda = this.search.funisVendas.find(funilVendaFilter => funilVendaFilter.id === this.idFunilVenda);
                                    this.select(funilVenda);
                                } else {  // Se não, selecionamos o primeiro funil de venda
                                    this.select(this.search.funisVendas[0]);
                                }
                            }


                            // Emitindo evento se o select possui algum funil de venda
                            this.possuiFunisVendas.emit(this.search?.funisVendas?.length > 0)
                        } else {
                            this.search = new FunilVendaSearch();
                        }
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, error.cause, error);
                        this.search = new FunilVendaSearch();
                    },
                    () => resolve()
                );
        });
    }

    /** Ao selecionar o funil de vendas */
    select(funilVenda: FunilVendaSearchFunilVenda) {
        this.idFunilVenda = funilVenda ? funilVenda.id : null;
        this.idFunilVendaChange.emit(this.idFunilVenda);
        this.funilVenda = funilVenda;
        this.funilVendaChange.emit(this.funilVenda);
    }
}
